/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import PropertySetter from './PropertySetter';
import EditModeType from './EditModeType';
import BaseObjectType from './BaseObjectType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject, new, updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // isShortcutOrAlias, getIdForExpression, set, getParentQuerySubject, isExtendedItem, refreshShortcutItemNorm, isEmptyDummyItemNormGroup, setMoserObject
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (static) // EditModeType
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (static) // new

/**
 * Static utility APIs to support MoserObject
 * @author  linzhao
 */
export default class MoserObjectUtils extends BaseMoserObject{

	static ID_SEPARATOR = ".";

	static STR_SLASH = "/";



	/**
	 * We have to treat PropertyType differently for WA data asset shaping For any new or updated PropertyType, the ObjectType will have an entry like 'Property.{name}' in its propertyOverride
	 * @param {MoserObject} objType  the parent of the PropertyType
	 * @param {PropertyType} item  the changed/new PropertyType
	 */
	static propertyOverrideForPropertyType(objType, item) {
		if (objType && objType instanceof ObjectType) {
			var obj = objType;
			var module = MoserObject.getModuleObject(objType);
			if (module && module.isOverrideMode() && item.getName() != null) {
				MoserObjectUtils._setPropertyOverride(obj.getFeatureName(96) + "." + item.getName(), obj);
			}
		}
	}

	/**
	 * We have to treat LocalRefType differently for WA data asset shaping For any changes in LocalRefType, the ItemHierarchy will have an entry like 'LocalRef' in its propertyOverride
	 * @param {MoserObject} itemHierarchy
	 */
	static propertyOverrideForLocalRef(itemHierarchy) {
		if (itemHierarchy && itemHierarchy instanceof ObjectType) {
			var obj = itemHierarchy;
			var module = MoserObject.getModuleObject(itemHierarchy);
			if (module && module.isOverrideMode()) {
				MoserObjectUtils._setPropertyOverride(obj.getFeatureName(242), obj);
			}
		}
	}

	static propertyOverrideForTaxonomyType(taxonomyObj) {
		var objType = MoserObjectUtils._getObjectTypeParent(taxonomyObj);
		if (objType) {
			MoserObject.updatePropertyOverride(objType, objType, 198, false);
		}
	}

	/**
	 * To support updating facet definition related properties in embedded module, we have to add the propertyOverride of the parent object (QueryItem) with 'facetDefinition'
	 * @param {MoserObject} facetObj
	 * @param  isAdd
	 */
	static propertyOverrideForFacetType(facetObj) {
		var objType = MoserObjectUtils._getObjectTypeParent(facetObj);
		if (objType) {
			MoserObject.updatePropertyOverride(objType, objType, 197, false);
		}
	}

	static _getObjectTypeParent(obj) {
		if (!obj) {
			return null;
		}
		if (obj instanceof ObjectType) {
			return obj;
		}
		return MoserObjectUtils._getObjectTypeParent(obj.getParent());
	}

	static _setPropertyOverride(featureName, obj) {
		var overrideList = MoserObjectUtils.getList(obj.basicGetPropertyOverride());
		for (var __i_enFor0 = 0, __exp_enFor0 = overrideList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var override = __exp_enFor0[__i_enFor0];
			if (override == featureName || "NEW" == override) {
				return;
			}
		}
		obj.addPropertyOverride(featureName);
	}

	static getQueryItems$0(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem()) {
				qItems.push(item.getQueryItem());
				Array.prototype.push.apply(qItems, MoserObjectUtils.getQueryItems$0(item.getQueryItem().basicGetItem()));
			} else if (item.getFolder()) {
				Array.prototype.push.apply(qItems, MoserObjectUtils.getQueryItems$0(item.getFolder().basicGetItem()));
			}
		}
		return qItems;
	}

	/**
	 * Returns a list of all query items in a query subject
	 * @param {QuerySubject} qs
	 * @return {Array}  List<QueryItem>
	 */
	static getQueryItems$1(qs) {
		return MoserObjectUtils.getQueryItems$0(qs.basicGetItem());
	}

	/**
	 * Returns a list of all item type folders in a query subject
	 * @param {QuerySubject} qs
	 * @return {Array}  List<Folder>
	 */
	static getItemTypeFolders$0(qs) {
		return MoserObjectUtils._getItemTypeFolders$1(qs.basicGetItem());
	}

	/**
	 * Returns a list of all first level query items in a query subject.
	 * @param {QuerySubject} qs
	 * @return {Array}  List<QueryItem>
	 */
	static getFirstLevelQueryItems$0(qs) {
		return MoserObjectUtils._getFirstLevelQueryItems$1(qs.basicGetItem());
	}

	static getFilters$0(items) {
		var filters = [];
		if (!items) {
			return filters;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getFilter()) {
				filters.push(item.getFilter());
			} else if (item.getFolder()) {
				Array.prototype.push.apply(filters, MoserObjectUtils.getFilters$0(item.getFolder().basicGetItem()));
			}
		}
		return filters;
	}

	static getFilters$1(qs) {
		return MoserObjectUtils.getFilters$0(qs.basicGetItem());
	}

	static getCalculations$0(items) {
		var calculations = [];
		if (!items) {
			return calculations;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getCalculation()) {
				var c = item.getCalculation();
				calculations.push(c);
				Array.prototype.push.apply(calculations, MoserObjectUtils.getCalculations$0(c.basicGetItem()));
			} else if (item.getFolder()) {
				Array.prototype.push.apply(calculations, MoserObjectUtils.getCalculations$0(item.getFolder().basicGetItem()));
			}
		}
		return calculations;
	}

	static getCalculations$1(qs) {
		return MoserObjectUtils.getCalculations$0(qs.basicGetItem());
	}

	/**
	 * get all global calculations in module
	 * @param {Module} module
	 * @return {Array}
	 */
	static getGlobalCalculations(module) {
		var calculations = [];
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor0 = 0, __exp_enFor0 = calcs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var c = __exp_enFor0[__i_enFor0];
				calculations.push(c);
				Array.prototype.push.apply(calculations, MoserObjectUtils.getCalculations(c.basicGetItem()));
			}
		}
		return calculations;
	}

	/**
	 * Return all FolderType in the MDTV as a flat list
	 * @param {Module} module
	 * @return {Array}
	 */
	static getFolderTypes(module) {
		var qFolders = [];
		var folders = module.basicGetMetadataTreeView();
		if (folders) {
			for (var __i_enFor0 = 0, __exp_enFor0 = folders, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folder = __exp_enFor0[__i_enFor0];
				qFolders.push(folder);
				MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
			}
		}
		return qFolders;
	}

	/**
	 * Returns a list of all item type folders in a list of item types.
	 * @param  List<ItemType>
	 * @return {Array}  List<Folder>
	 */
	static _getItemTypeFolders$1(items) {
		var folders = [];
		if (!items) {
			return folders;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getFolder()) {
				folders.push(item.getFolder());
				Array.prototype.push.apply(folders, MoserObjectUtils._getItemTypeFolders$1(item.getFolder().basicGetItem()));
			}
		}
		return folders;
	}

	/**
	 * @param {Array} qFolders
	 * @param {Array} folderItems
	 * @return {void}
	 */
	static _collectFolderTypes(qFolders, folderItems) {
		if (folderItems) {
			for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var folderItem = __exp_enFor0[__i_enFor0];
				var folder = folderItem.getFolder();
				if (folder) {
					qFolders.push(folder);
					MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
				}
			}
		}
	}

	/**
	 * Retrieve all items of type 'Filter/Folder/ItemHierarchy/NamedSet/QueryItem/Calculation' under a 'QuerySubject/QueryItem/Folder'
	 * @param {ObjectType} obj
	 * @return {Array}
	 */
	static getItems(obj) {
		var qItems = [];
		var objectType = obj.getObjectType();
		if ("QuerySubject" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		} else if ("QueryItem" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		} else if ("Folder" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		} else if ("Calculation" == objectType) {
			MoserObjectUtils._collectItems(qItems, (obj).basicGetItem());
		}
		return qItems;
	}

	/**
	 * Returns a list of all first level query items in a list of ItemTypes including under folders.
	 * @param  qs
	 * @return {Array}  List<QueryItem>
	 */
	static _getFirstLevelQueryItems$1(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var queryItem = item.getQueryItem();
			if (queryItem) {
				qItems.push(queryItem);
				continue;
			}
			var folder = item.getFolder();
			if (folder) {
				Array.prototype.push.apply(qItems, MoserObjectUtils._getFirstLevelQueryItems$1(folder.basicGetItem()));
			}
		}
		return qItems;
	}

	/**
	 * Collect all items of an ItemType list into a list.
	 * @param {Array} allItems
	 * @param {Array} items
	 */
	static _collectItems(allItems, items) {
		if (items) {
			for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var item = __exp_enFor0[__i_enFor0];
				if (item.getFilter()) {
					allItems.push(item.getFilter());
				} else if (item.getFolder()) {
					var f = item.getFolder();
					allItems.push(f);
					MoserObjectUtils._collectItems(allItems, f.basicGetItem());
				} else if (item.getItemHierarchy()) {
					allItems.push(item.getItemHierarchy());
				} else if (item.getNamedSet()) {
					allItems.push(item.getNamedSet());
				} else if (item.getCalculation()) {
					var calc = item.getCalculation();
					allItems.push(calc);
					MoserObjectUtils._collectItems(allItems, calc.basicGetItem());
				} else if (item.getQueryItem()) {
					var qi = item.getQueryItem();
					allItems.push(qi);
					MoserObjectUtils._collectItems(allItems, qi.basicGetItem());
				}
			}
		}
	}

	static _removeQueryItem$0(items, qi) {
		if (!items) {
			return;
		}
		var id = qi.getIdentifier();
		for (var i = items.length - 1; i >= 0; --i) {
			var item = items[i];
			var qitem = item.getQueryItem();
			if (qitem && qitem.getIdentifier() == id) {
				items.splice(i, 1);
				break;
			} else if (item.getFolder()) {
				MoserObjectUtils._removeQueryItem$0(item.getFolder().basicGetItem(), qi);
				var folderItems = item.getFolder().basicGetItem();
				if (!folderItems || folderItems.length==0) {
					items.splice(i, 1);
				}
			}
		}
	}

	static removeQueryItem$1(qs, qi) {
		MoserObjectUtils._removeQueryItem$0(qs.basicGetItem(), qi);
	}

	static getMeasures$0(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem()) {
				qItems.push(item.getQueryItem());
				Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getQueryItem().basicGetItem()));
			} else if (item.getFolder()) {
				Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getFolder().basicGetItem()));
			}
		}
		return qItems;
	}

	static getMeasures$1(qs) {
		return MoserObjectUtils.getMeasures$0(qs.basicGetItem());
	}

	static getItemNormalizationGroups(qs) {
		var rt = [];
		var itemNormalization = qs.getItemNormalization();
		if (!itemNormalization) {
			return rt;
		}
		var grps = itemNormalization.basicGetItemNormalizationGroup();
		if (grps) {
			Array.prototype.push.apply(rt, grps);
		}
		return rt;
	}

	static getList(lst) {
		var rt = lst;
		if (!rt) {
			rt = [];
		}
		return rt;
	}

	/**
	 * Returns a list of items in query subject that match with the identifier
	 * @param {QuerySubject} qs
	 * @param {String} identifier
	 */
	static getObjectTypesById(qs, identifier) {
		var objectTypes = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = MoserObjectUtils.getItems(qs), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			if (identifier != null && identifier == obj.getIdentifier()) {
				objectTypes.push(obj);
			}
		}
		return objectTypes;
	}

	/**
	 * Returns a list of all query subjects that reference parent query subject of obj directly.
	 * @param {MoserObject} obj
	 * @return {Array}  list of query subjects
	 */
	static getShortcutReferences(obj) {
		var references = [];
		if (!obj) {
			return references;
		}
		var qsParent = PropertySetter.getParentQuerySubject(obj);
		if (!qsParent && "QuerySubject" == obj.getObjectType()) {
			qsParent = obj;
		}
		if (!qsParent) {
			return references;
		}
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return references;
		}
		var identifier = qsParent.getIdentifier();
		var qsList = module.getQuerySubject();
		var scMap = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (PropertySetter.isShortcutOrAlias(qs, true)) {
				var qsRefs = qs.basicGetRef();
				var isValidShortcut = PropertySetter.isShortcutOrAlias(qs, false);
				if (isValidShortcut) {
					qsRefs = qs.basicGetOriginalRef();
				}
				if (!qsRefs || qsRefs.length != 1) {
					continue;
				}
				var ref = qsRefs[0];
				if (ref.split(new RegExp("\\.")).length == 1) {
					if (isValidShortcut) {
						scMap[qs.getIdentifier()] = qs;
					}
					if (ref == identifier) {
						references.push(qs);
					}
				}
			}
		}
		if (MoserObjectUtils._isCircularShortcutReference(qsParent, scMap)) {
			return [];
		}
		return references;
	}

	static sortByLabel(unsortedList) {
		var sortedList = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = unsortedList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var objToInsertLabel = obj.getLabel();
			var index = -1;
			for (var i = 0; i < sortedList.length; ++i) {
				var label = sortedList[i].getLabel();
				if (objToInsertLabel.localeCompare(label) < 0 || objToInsertLabel.localeCompare(label) == 0) {
					index = i;
					break;
				}
			}
			if (index == -1) {
				sortedList.push(obj);
			} else {
				sortedList.splice(index, 0, obj);
			}
		}
		return sortedList;
	}

	/**
	 * Adds extended query item in shortcut item normalization. If extended query item is exists in item normalization as an attribute, remove attribute and re-add query item to item normalization.
	 * @param {BaseQueryItemType} baseQI  query item obj
	 */
	static updateQIItemNorm(baseQI) {
		if (!("QueryItem" == baseQI.getObjectType())) {
			return;
		}
		var qi = baseQI;
		var identifier = qi.getIdentifier();
		if (identifier == null) {
			return;
		}
		var qs = PropertySetter.getParentQuerySubject(qi);
		var isShortcutOrAlias = PropertySetter.isShortcutOrAlias(qs, false);
		if (isShortcutOrAlias) {
			PropertySetter.refreshShortcutItemNorm(qs, false);
		}
	}

	/**
	 * Updates all shortcuts and aliases referencing the query subject of an object and performs set for any set feature.
	 * @param {MoserObject} aObj        obj under a query subject
	 * @param {int} featureID  feature to set.
	 * @param {BaseMoserObject} oldValue   previous value.
	 * @param {BaseMoserObject} newValue   value to set to.
	 */
	static updateShortcutSet(aObj, featureID, oldValue, newValue) {
		if (!(MoserObjectUtils._isModuleOverrideMode(aObj))) {
			return;
		}
		var objType = aObj.getObjectType();
		if (197 == featureID || "FacetType" == objType || "SortItem" == objType) {
			MoserObjectUtils._updateShortcutFacetSet(aObj, featureID, newValue);
			return;
		}
		if (featureID == 284 || featureID == 287 || featureID == 285 || featureID == 286 || featureID == 130) {
			MoserObjectUtils._setToShortcut(aObj, featureID, newValue);
			return;
		}
		if ("SplitType" == objType) {
			MoserObjectUtils.updateShortcutSplitTypeSet(aObj, featureID, newValue);
			return;
		}
		if ("TaxonomyType" == objType) {
			MoserObjectUtils.updateShortcutTaxonomySet(aObj, featureID, newValue);
			return;
		}
		if (!(aObj instanceof ObjectType)) {
			return;
		}
		var obj = aObj;
		if ("QuerySubject" == objType) {
			if (91 != featureID && 127 != featureID) {
				MoserObjectUtils.updateShortcutQSPropSet(obj, featureID, newValue);
			}
			return;
		}
		var references = MoserObjectUtils.getShortcutReferences(obj);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var refObjs = null;
			if (91 == featureID && oldValue != null) {
				if ("QueryItem" == obj.getObjectType()) {
					for (var __i_enFor1 = 0, __exp_enFor1 = MoserObjectUtils.getQueryItems(qs), __len_enFor1 = __exp_enFor1.length;
							__i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var refQi = __exp_enFor1[__i_enFor1];
						if (newValue === refQi.getIdentifier() && PropertySetter.isExtendedItem(refQi)) {
							MoserObjectUtils._removeAttributeFromQuerySubject(qs, refQi.getIdentifier(), true);
						}
					}
				}
				refObjs = MoserObjectUtils.getObjectTypesById(qs, oldValue);
			} else {
				refObjs = MoserObjectUtils.getObjectTypesById(qs, obj.getIdentifier());
			}
			for (var __i_enFor2 = 0, __exp_enFor2 = refObjs, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var refObj = __exp_enFor2[__i_enFor2];
				if (refObj.getEditMode() == EditModeType.RO) {
					refObj.set(featureID, newValue);
					break;
				}
			}
		}
	}

	/**
	 * Updates all shortcuts and aliases referencing the query subject and performs set for any set feature.
	 * @param {QuerySubject} qs         query subject
	 * @param {int} featureID  feature to set.
	 * @param {BaseMoserObject} newValue   value to set to.
	 */
	static updateShortcutQSPropSet(qs, featureID, newValue) {
		if (!(MoserObjectUtils._isModuleOverrideMode(qs))) {
			return;
		}
		var references = MoserObjectUtils.getShortcutReferences(qs);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var refQS = __exp_enFor0[__i_enFor0];
			if (featureID == 12) {
				var cloned = MoserObjectUtils._cloneAndMergeItemNormalization(refQS, newValue);
				PropertySetter.set(refQS, featureID, cloned, false);
				MoserObjectUtils.updateShortcutQSPropSet(refQS, featureID, cloned);
				continue;
			}
			var propertyOverride = refQS.basicGetPropertyOverride();
			if (!propertyOverride || !(propertyOverride.indexOf(refQS.getFeatureName(featureID))> -1)) {
				PropertySetter.set(refQS, featureID, newValue, false);
				MoserObjectUtils.updateShortcutQSPropSet(refQS, featureID, newValue);
			}
		}
	}

	/**
	 * Updates all shortcuts and aliases referencing the query subject of an object and performs addAt for any list feature.
	 * @param {MoserObject} aObj   obj under a query subject
	 * @param {int} featureID  feature to add to.
	 * @param {int} position   position to add at.
	 * @param {BaseMoserObject} value      value to add.
	 */
	static updateShortcutAddAt(aObj, featureID, position, value) {
		if (featureID == 167 || featureID == 85 || featureID == 88 || featureID == 96 || featureID == 100) {
			if (MoserObjectUtils._isModuleOverrideMode(aObj)) {
				MoserObjectUtils._addToShortcutAt(aObj, featureID, position, value);
			}
			return;
		}
		if (!(value instanceof MoserObject) || !(aObj instanceof ObjectType)) {
			return;
		}
		var obj = aObj;
		var moserObj = value;
		try {
			var references = MoserObjectUtils.getShortcutReferences(obj);
			for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qs = __exp_enFor0[__i_enFor0];
				var valueClone = moserObj.clone();
				var refObjs = MoserObjectUtils.getObjectTypesById(qs, obj.getIdentifier());
				for (var __i_enFor1 = 0, __exp_enFor1 = refObjs, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var refObj = __exp_enFor1[__i_enFor1];
					if (refObj.getEditMode() == EditModeType.RO) {
						refObj.addAt(featureID, position, valueClone);
						break;
					}
				}
			}
		} catch (e) {
			throw e;
		}

	}

	/**
	 * Updates all shortcuts and aliases referencing the query subject of an object and performs removeAt for any list feature.
	 * @param {MoserObject} aObj        obj under a query subject
	 * @param {int} featureID  feature to remove from.
	 * @param {int} position   position to remove from.
	 */
	static updateShortcutRemoveAt(aObj, featureID, position) {
		if (featureID == 167 || featureID == 85 || featureID == 96 || featureID == 88) {
			if (MoserObjectUtils._isModuleOverrideMode(aObj)) {
				MoserObjectUtils._removeFromShortcutAt(aObj, featureID, position);
			}
			return;
		}
		if (!(aObj instanceof ObjectType)) {
			return;
		}
		var obj = aObj;
		var references = MoserObjectUtils.getShortcutReferences(obj);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var refObjs = MoserObjectUtils.getObjectTypesById(qs, obj.getIdentifier());
			for (var __i_enFor1 = 0, __exp_enFor1 = refObjs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var refObj = __exp_enFor1[__i_enFor1];
				if (refObj.getEditMode() == EditModeType.RO) {
					refObj.removeAt(featureID, position);
					break;
				}
			}
		}
	}

	/**
	 * Updates the split type setter of the shared query item from any referencing shortcuts and aliases.
	 * @param {SplitType} splitDef   split definition
	 * @param {int} featureId  feature id
	 * @param {BaseMoserObject} newValue   value to set
	 */
	static updateShortcutSplitTypeSet(splitDef, featureId, newValue) {
		if (!(MoserObjectUtils._isModuleOverrideMode(splitDef))) {
			return;
		}
		var parent = splitDef.getParent();
		if (!parent || !("QueryItem" == parent.getObjectType())) {
			return;
		}
		var targetQueryItem = parent;
		var index = targetQueryItem.getSplitDefinition().indexOf(splitDef);
		var references = MoserObjectUtils.getShortcutReferences(targetQueryItem);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var refObjs = MoserObjectUtils.getObjectTypesById(qs, targetQueryItem.getIdentifier());
			for (var __i_enFor1 = 0, __exp_enFor1 = refObjs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var refObj = __exp_enFor1[__i_enFor1];
				if ("QueryItem" == refObj.getObjectType() && refObj.getEditMode() == EditModeType.RO) {
					var refQI = refObj;
					var refSplitTypes = refQI.getSplitDefinition();
					if (!(refSplitTypes.length==0)) {
						refSplitTypes[index].set(featureId, newValue);
					}
					break;
				}
			}
		}
	}

	/**
	 * Updates the taxonomy setter of the shared query item from any referencing shortcuts and aliases.
	 * @param {TaxonomyType} taxonomy   taxonomy obj to be updated
	 * @param {int} featureId  feature id
	 * @param {BaseMoserObject} newValue   value to set
	 */
	static updateShortcutTaxonomySet(taxonomy, featureId, newValue) {
		if (!(MoserObjectUtils._isModuleOverrideMode(taxonomy))) {
			return;
		}
		var parent = taxonomy.getParent();
		if (!parent || !("QueryItem" == parent.getObjectType())) {
			return;
		}
		var targetQueryItem = parent;
		var index = targetQueryItem.getTaxonomy().indexOf(taxonomy);
		var references = MoserObjectUtils.getShortcutReferences(targetQueryItem);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var refObjs = MoserObjectUtils.getObjectTypesById(qs, targetQueryItem.getIdentifier());
			for (var __i_enFor1 = 0, __exp_enFor1 = refObjs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var refObj = __exp_enFor1[__i_enFor1];
				if ("QueryItem" == refObj.getObjectType() && refObj.getEditMode() == EditModeType.RO) {
					var refQI = refObj;
					var refTaxonomyTypes = refQI.getTaxonomy();
					if (!(refTaxonomyTypes.length==0)) {
						refTaxonomyTypes[index].set(featureId, newValue);
					}
					break;
				}
			}
		}
	}

	/**
	 * Returns the long identifier of a moser Object. Returns null if moser object does not have a long identifier.
	 * @param {MoserObject} obj   MoserObject
	 */
	static getLongIdentifier(obj) {
		if (!obj) {
			return null;
		}
		if ("Segment" == obj.getObjectType()) {
			var seg = obj;
			var parent = MoserObjectUtils.getParentObjectOfType(seg, "DrillGroup");
			if (parent) {
				return "/" + PropertySetter.getIdForExpression(parent) + "/" + seg.getIdentifier();
			}
		} else if ("Folder" == obj.getObjectType() || "FolderType" == obj.getObjectType()) {
			var chain = [];
			var folder = obj;
			if (folder.getIdentifier() == null) {
				return null;
			}
			chain.push(folder);
			var parent = folder.getParent();
			while (parent) {
				if ("QuerySubject" == parent.getObjectType()) {
					chain.push(parent);
					break;
				} else if ("Folder" == parent.getObjectType()) {
					chain.push(parent);
				} else if ("FolderType" == parent.getObjectType() && (parent).getIdentifier() != null) {
					chain.push(parent);
				}
				parent = parent.getParent();
			}
			return MoserObjectUtils._generateFolderLongId(chain);
		} else if (obj instanceof BaseObjectType) {
			var idForExpression = (obj).basicGetIdForExpression();
			if (idForExpression != null) {
				return idForExpression;
			}
			return PropertySetter.getIdForExpression(obj);
		}
		return null;
	}

	/**
	 * Generates long identifier for Folders in MDTV and Folders within a Query Subject.
	 * @param {Array} chain   List of objects and parent objects. First element is object. Last is the top parent.
	 */
	static _generateFolderLongId(chain) {
		var longId = "";
		for (var i = chain.length - 1; i >= 0; --i) {
			var chainObj = chain[i];
			if (!("QuerySubject" == chainObj.getObjectType())) {
				longId+=("/");
			}
			longId+=(chainObj.getIdentifier());
		}
		return longId;
	}

	/**
	 * Returns true parent module of a moser object is in override mode.
	 * @param {MoserObject} obj  moser object
	 * @return {boolean}  t/f
	 */
	static _isModuleOverrideMode(obj) {
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return false;
		}
		return module.isOverrideMode();
	}

	/**
	 * @param {MoserObject} moserObj
	 * @param {String} type
	 * @return {MoserObject}
	 */
	static getParentObjectOfType(moserObj, type) {
		if (!moserObj) {
			return null;
		}
		var parent = moserObj.getParent();
		if (!parent) {
			return null;
		}
		var objType = parent.getObjectType();
		if (type == objType) {
			return parent;
		}
		return MoserObjectUtils.getParentObjectOfType(parent, type);
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} featureID
	 * @param {BaseMoserObject} newValue
	 */
	static _updateShortcutFacetSet(aObj, featureID, newValue) {
		var queryItem;
		if (197 == featureID) {
			queryItem = aObj;
		} else {
			queryItem = MoserObjectUtils.getParentObjectOfType(aObj, "QueryItem");
		}
		if (!queryItem) {
			return;
		}
		var id = queryItem.getIdentifier();
		var references = MoserObjectUtils.getShortcutReferences(aObj);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var refObjs = MoserObjectUtils.getObjectTypesById(qs, id);
			for (var __i_enFor1 = 0, __exp_enFor1 = refObjs, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var o = __exp_enFor1[__i_enFor1];
				if (!("QueryItem" == o.getObjectType())) {
					continue;
				}
				var refQueryItem = o;
				if (197 == featureID) {
					var clonedFacet = null;
					if (newValue != null) {
						try {
							clonedFacet = (newValue).clone();
							clonedFacet.setParent(refQueryItem);
						} catch (e) {
							throw e;
						}

					}
					PropertySetter.set(refQueryItem, 197, clonedFacet, false);
					MoserObjectUtils._updateShortcutFacetSet(refQueryItem, featureID, clonedFacet);
					continue;
				}
				var facet = refQueryItem.getFacetDefinition();
				if (!facet) {
					continue;
				}
				if ("FacetType" == aObj.getObjectType()) {
					if (98 == featureID) {
						PropertySetter.setMoserObject(facet, featureID, newValue);
						MoserObjectUtils._updateShortcutFacetSet(facet, featureID, newValue);
					} else if (26 == featureID) {
						var clonedSortList = null;
						if (newValue != null) {
							try {
								clonedSortList = (newValue).clone();
								clonedSortList.setParent(facet);
							} catch (e) {
								throw e;
							}

						}
						PropertySetter.setMoserObject(facet, featureID, clonedSortList);
						MoserObjectUtils._updateShortcutFacetSet(facet, featureID, clonedSortList);
					}
				} else if ("SortItem" == aObj.getObjectType()) {
					var sortList = facet.getSortList();
					if (sortList) {
						var sortItems = sortList.basicGetSortItem();
						if (sortItems && sortItems.length == 1) {
							PropertySetter.setMoserObject(sortItems[0], featureID, newValue);
							MoserObjectUtils._updateShortcutFacetSet(sortItems[0], featureID, newValue);
						}
					}
				}
			}
		}
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} featureID
	 * @param {BaseMoserObject} newValue
	 */
	static _setToShortcut(aObj, featureID, newValue) {
		if (featureID == 130) {
			if ("PropertyType" == aObj.getObjectType()) {
				if ("_MUI_data_cache" == (aObj).getName()) {
					var references = MoserObjectUtils.getShortcutReferences(aObj);
					for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
							__i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						var propLst = qs.basicGetProperty();
						if (!propLst) {
							continue;
						}
						var dataCacheExpiryProp = null;
						for (var __i_enFor1 = 0, __exp_enFor1 = propLst, __len_enFor1 = __exp_enFor1.length;
								__i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var p = __exp_enFor1[__i_enFor1];
							if ("_MUI_data_cache" == p.getName()) {
								dataCacheExpiryProp = p;
								break;
							}
						}
						if (dataCacheExpiryProp) {
							PropertySetter.setMoserObject(dataCacheExpiryProp, featureID, newValue);
							MoserObjectUtils._setToShortcut(dataCacheExpiryProp, featureID, newValue);
						}
					}
				}
			}
			return;
		}
		var grp = MoserObjectUtils.getParentObjectOfType(aObj, "ItemNormalizationGroupType");
		if (!grp) {
			return;
		}
		var references = MoserObjectUtils.getShortcutReferences(grp);
		for (var __i_enFor2 = 0, __exp_enFor2 = references, __len_enFor2 = __exp_enFor2.length;
				__i_enFor2 < __len_enFor2; ++__i_enFor2) {
			var qs = __exp_enFor2[__i_enFor2];
			var scGrp = MoserObjectUtils._getItemNormalizationGroupById(qs.getItemNormalization(), grp.getIdentifier());
			if (!scGrp) {
				continue;
			}
			if (featureID == 285 || featureID == 286) {
				var scKey = scGrp.getKey();
				if (scKey) {
					PropertySetter.setMoserObject(scKey, featureID, newValue);
					MoserObjectUtils._setToShortcut(scKey, featureID, newValue);
				}
			} else if (featureID == 287) {
				var attr = aObj;
				var scAttr = MoserObjectUtils._getAttributeByRefItem(scGrp, attr.getItemRef());
				if (scAttr) {
					PropertySetter.setMoserObject(scAttr, featureID, newValue);
					MoserObjectUtils._setToShortcut(scAttr, featureID, newValue);
				}
			}
		}
	}

	/**
	 * @param {ItemNormalizationType} scItmNorm
	 * @param {String} grpId
	 * @return {ItemNormalizationGroupType}
	 */
	static _getItemNormalizationGroupById(scItmNorm, grpId) {
		if (grpId == null || grpId.length === 0 || !scItmNorm) {
			return null;
		}
		var scGrps = scItmNorm.basicGetItemNormalizationGroup();
		if (!scGrps) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = scGrps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (grpId == g.getIdentifier()) {
				return g;
			}
		}
		return null;
	}

	/**
	 * Returns the ItemNormalizationGroupType the query item identifier belongs to.
	 * @param {QuerySubject} qs    query subject
	 * @param {String} qiId  query item identifier
	 * @return {ItemNormalizationGroupType}
	 */
	static getItemNormalizationGroupTypeByRefItem(qs, qiId) {
		if (!qs || qiId == null) {
			return null;
		}
		var itemNorm = qs.getItemNormalization();
		if (!itemNorm) {
			return null;
		}
		var groupTypeList = itemNorm.basicGetItemNormalizationGroup();
		if (!groupTypeList) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = groupTypeList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var groupType = __exp_enFor0[__i_enFor0];
			var key = groupType.getKey();
			if (key && qiId == key.getItemRef()) {
				return groupType;
			}
			var attributes = groupType.basicGetAttribute();
			if (!attributes) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = attributes, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var attribute = __exp_enFor1[__i_enFor1];
				if (qiId == attribute.getItemRef()) {
					return groupType;
				}
			}
		}
		return null;
	}

	/**
	 * @param {ItemNormalizationGroupType} grp
	 * @param {String} qiId
	 * @return {Attribute}
	 */
	static _getAttributeByRefItem(grp, qiId) {
		var attrs = grp.basicGetAttribute();
		if (!attrs || attrs.length==0) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = attrs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var attr = __exp_enFor0[__i_enFor0];
			if (qiId == attr.getItemRef()) {
				return attr;
			}
		}
		return null;
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} featureID
	 * @param {int} position
	 * @param {BaseMoserObject} value
	 */
	static _addToShortcutAt(aObj, featureID, position, value) {
		if (featureID == 167) {
			MoserObjectUtils._addItemNormalizationGroupToShortcutAt(aObj, position, value);
		} else if (featureID == 85 || featureID == 88) {
			MoserObjectUtils._addItemNormalizationGroupPropsToShortcutAt(aObj, featureID, position, value);
		} else if (featureID == 96) {
			MoserObjectUtils._addPropertyToShortcutAt(aObj, position, value);
		} else if (featureID == 100) {
			var sortList = MoserObjectUtils.getParentObjectOfType(value, "SortListType");
			var facet = MoserObjectUtils.getParentObjectOfType(sortList, "FacetType");
			if (facet) {
				MoserObjectUtils._updateShortcutFacetSet(facet, 26, sortList);
			}
		}
	}

	/**
	 * @param {ItemNormalizationType} itmNorm
	 * @param {int} position
	 * @param {ItemNormalizationGroupType} newGrp
	 */
	static _addItemNormalizationGroupToShortcutAt(itmNorm, position, newGrp) {
		var references = MoserObjectUtils.getShortcutReferences(itmNorm);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var scItmNorm = qs.getItemNormalization();
			if (!scItmNorm) {
				scItmNorm = MoserObjectUtils._cloneItemNormalizationType(itmNorm);
				if (scItmNorm) {
					qs.setItemNormalization(scItmNorm);
				}
				continue;
			}
			var cloned = null;
			try {
				cloned = newGrp.clone();
			} catch (e) {
				throw e;
			}

			PropertySetter.set(cloned, 161, EditModeType.RO, false);
			var scGrps = scItmNorm.getItemNormalizationGroup();
			var hasDummy = false;
			var newGrpId = newGrp.getIdentifier();
			if (newGrpId != null && "dummyGroup4ShortcutAlias" == newGrpId) {
				for (var __i_enFor1 = 0, __exp_enFor1 = scGrps, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var scGrp = __exp_enFor1[__i_enFor1];
					if ("dummyGroup4ShortcutAlias" == scGrp.getIdentifier()) {
						hasDummy = true;
					}
				}
			}
			if (!hasDummy) {
				scGrps.splice(position, 0, cloned);
				cloned.setParent(scItmNorm);
			}
			MoserObjectUtils._addItemNormalizationGroupToShortcutAt(scItmNorm, position, cloned);
		}
	}

	/**
	 * Removes attribute with provided item ref from query subject.
	 * @param {QuerySubject} qs                QuerySubject
	 * @param {String} itemRef           identifier of attribute to be removed
	 * @param {boolean} removeDummyGroup  removes dummy group if empty
	 */
	static _removeAttributeFromQuerySubject(qs, itemRef, removeDummyGroup) {
		var refGroupType = MoserObjectUtils.getItemNormalizationGroupTypeByRefItem(qs, itemRef);
		if (refGroupType) {
			var refAttribute = MoserObjectUtils._getAttributeByRefItem(refGroupType, itemRef);
			refGroupType.removeAttribute(refAttribute);
			if (removeDummyGroup && PropertySetter.isEmptyDummyItemNormGroup(refGroupType)) {
				qs.getItemNormalization().removeItemNormalizationGroup(refGroupType);
			}
		}
	}

	/**
	 * @param {ItemNormalizationGroupType} grp
	 * @param {int} featureID
	 * @param {int} position
	 * @param {BaseMoserObject} value
	 */
	static _addItemNormalizationGroupPropsToShortcutAt(grp, featureID, position, value) {
		var references = MoserObjectUtils.getShortcutReferences(grp);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			var scGrp = MoserObjectUtils._getItemNormalizationGroupById(qs.getItemNormalization(), grp.getIdentifier());
			if (!scGrp) {
				continue;
			}
			if (featureID == 85) {
				var parentRefLst = scGrp.getParentGroupRef();
				parentRefLst.splice(position, 0, value);
			} else if (featureID == 88) {
				var attribute = value;
				if ("dummyGroup4ShortcutAlias" == scGrp.getIdentifier()) {
					MoserObjectUtils._removeAttributeFromQuerySubject(qs, attribute.getItemRef(), false);
				} else {
					MoserObjectUtils._removeAttributeFromQuerySubject(qs, attribute.getItemRef(), true);
				}
				var attrLst = scGrp.getAttribute();
				var cloned = null;
				try {
					cloned = (value).clone();
				} catch (e) {
					throw e;
				}

				attrLst.splice(position, 0, cloned);
				cloned.setParent(scGrp);
			}
			MoserObjectUtils._addItemNormalizationGroupPropsToShortcutAt(scGrp, featureID, position, value);
		}
	}

	/**
	 * @param {QuerySubject} scQS
	 * @param {BaseMoserObject} newValue
	 * @return {ItemNormalizationType}
	 */
	static _cloneAndMergeItemNormalization(scQS, newValue) {
		var cloned = MoserObjectUtils._cloneItemNormalizationType(newValue);
		if (cloned) {
			cloned.setParent(scQS);
		}
		MoserObjectUtils._mergeItemNormalization(cloned, scQS.getItemNormalization());
		return cloned;
	}

	/**
	 * @param {BaseMoserObject} newValue
	 * @return {ItemNormalizationType}
	 */
	static _cloneItemNormalizationType(newValue) {
		if (newValue == null) {
			return null;
		}
		try {
			return (newValue).clone();
		} catch (e) {
			throw e;
		}

	}

	/**
	 * @param {ItemNormalizationType} cloned
	 * @param {ItemNormalizationType} existing
	 */
	static _mergeItemNormalization(cloned, existing) {
		if (!cloned) {
			return;
		}
		var clonedGrps = cloned.basicGetItemNormalizationGroup();
		if (!clonedGrps || clonedGrps.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = clonedGrps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			PropertySetter.set(g, 161, EditModeType.RO, false);
		}
		if (!existing) {
			return;
		}
		var exsitingGrps = existing.basicGetItemNormalizationGroup();
		if (!exsitingGrps || exsitingGrps.length==0) {
			return;
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = exsitingGrps, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var grp = __exp_enFor1[__i_enFor1];
			var attrs = grp.basicGetAttribute();
			if (!attrs || attrs.length==0) {
				continue;
			}
			var clonedGrp = MoserObjectUtils._getItemNormalizationGroupById(cloned, grp.getIdentifier());
			if (!clonedGrp) {
				continue;
			}
			for (var __i_enFor2 = 0, __exp_enFor2 = attrs, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var attr = __exp_enFor2[__i_enFor2];
				var qiId = attr.getItemRef();
				if (qiId == null || qiId.length === 0 || MoserObjectUtils._getAttributeByRefItem(clonedGrp, qiId)) {
					continue;
				}
				var clonedAttrs = clonedGrp.getAttribute();
				clonedAttrs.push(attr);
				attr.setParent(clonedGrp);
			}
		}
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} featureID
	 * @param {int} position
	 */
	static _removeFromShortcutAt(aObj, featureID, position) {
		if (featureID == 96 && "QuerySubject" == aObj.getObjectType()) {
			if (!(PropertySetter.isShortcutOrAlias(aObj, true))) {
				var propLst = (aObj).getProperty();
				if (propLst.length > position) {
					var propType = propLst[position];
					if ("_MUI_data_cache" == propType.getName()) {
						var references = MoserObjectUtils.getShortcutReferences(aObj);
						for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
								__i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var qs = __exp_enFor0[__i_enFor0];
							MoserObjectUtils._removeDataCachePropertyFromShortcuts(qs);
						}
					}
				}
			}
			return;
		}
		var references = MoserObjectUtils.getShortcutReferences(aObj);
		for (var __i_enFor1 = 0, __exp_enFor1 = references, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qs = __exp_enFor1[__i_enFor1];
			var scItmNorm = qs.getItemNormalization();
			if (!scItmNorm) {
				continue;
			}
			if (featureID == 167) {
				var scGrps = scItmNorm.basicGetItemNormalizationGroup();
				if (!scGrps) {
					continue;
				}
				var scGroup = scGrps[position];
				if ("dummyGroup4ShortcutAlias" == scGroup.getIdentifier() && scGroup.basicGetAttribute() && scGroup.basicGetAttribute().length != 0) {
					continue;
				}
				scGrps.splice(position, 1);
				MoserObjectUtils._removeFromShortcutAt(scItmNorm, featureID, position);
			} else if (featureID == 85 || featureID == 88) {
				var scGrp = MoserObjectUtils._getItemNormalizationGroupById(scItmNorm, (aObj).getIdentifier());
				if (!scGrp) {
					continue;
				}
				if (featureID == 85) {
					var parentRefLst = scGrp.getParentGroupRef();
					parentRefLst.splice(position, 1);
				} else if (featureID == 88) {
					var attrLst = scGrp.getAttribute();
					attrLst.splice(position, 1);
				}
				MoserObjectUtils._removeFromShortcutAt(scGrp, featureID, position);
			}
		}
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} position
	 * @param {PropertyType} value
	 */
	static _addPropertyToShortcutAt(aObj, position, value) {
		if ("QuerySubject" == aObj.getObjectType()) {
			if ("_MUI_data_cache" == value.getName()) {
				var references = MoserObjectUtils.getShortcutReferences(aObj);
				for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					var propLst = qs.getProperty();
					var cloned = null;
					try {
						cloned = value.clone();
					} catch (e) {
						throw e;
					}

					propLst.push(cloned);
					cloned.setParent(qs);
					MoserObjectUtils._addPropertyToShortcutAt(qs, position, value);
				}
			}
		}
	}

	/**
	 * Returns true if the shortcut is indirectly referencing itself through other shortcuts.
	 * @param {QuerySubject} shortcut
	 * @param {Map} scMap     maps identifier to shortcut with a one-part reference.
	 * @return {boolean}  boolean
	 */
	static _isCircularShortcutReference(shortcut, scMap) {
		var visited = {};
		if (!(scMap.hasOwnProperty(shortcut.getIdentifier()))) {
			return false;
		}
		var current = shortcut;
		while (current) {
			if (visited.hasOwnProperty(current.getIdentifier())) {
				return true;
			}
			visited[current.getIdentifier()] = 1;
			var originalRef = current.getOriginalRef()[0];
			current = scMap[originalRef];
		}
		return false;
	}

	/**
	 * Returns true if the object is marked as hidden
	 * @param {ObjectType} obj
	 * @param {boolean} bIncludeParent
	 */
	static isHidden(obj, bIncludeParent) {
		if (!obj || "Module" == obj.getObjectType() || "QuerySubject" == obj.getObjectType()) {
			return false;
		}
		var bHidden = obj.isHidden() != null && obj.isHidden();
		if (bHidden) {
			return true;
		}
		if (bIncludeParent) {
			var parent = obj.getParent();
			while (parent) {
				if (parent instanceof ObjectType) {
					var parentObjType = parent;
					if ("Folder" == parentObjType.getObjectType()) {
						return MoserObjectUtils.isHidden(parent, bIncludeParent);
					}
				}
				parent = parent.getParent();
			}
		}
		return false;
	}

	/**
	 * Removes the _MUI_data_cache property from a shortcut and any shortcuts and aliases referencing it.
	 * @param {QuerySubject} shortcut
	 */
	static _removeDataCachePropertyFromShortcuts(shortcut) {
		var propLst = shortcut.getProperty();
		for (var i = propLst.length - 1; i >= 0; --i) {
			var propType = propLst[i];
			if ("_MUI_data_cache" == propType.getName()) {
				propLst.splice(i, 1);
			}
		}
		var references = MoserObjectUtils.getShortcutReferences(shortcut);
		for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			MoserObjectUtils._removeDataCachePropertyFromShortcuts(qs);
		}
	}

	static containsUsage(obj, expectedUsage) {
		if ("QueryItem" == obj.getObjectType()) {
			return expectedUsage == (obj).getUsage();
		}
		if ("Calculation" == obj.getObjectType()) {
			return expectedUsage == (obj).getUsage();
		}
		return false;
	}

	static getQueryItems(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getQueryItems$0(a0);
		}
		return MoserObjectUtils.getQueryItems$1(a0);
	}

	static getItemTypeFolders(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getItemTypeFolders$1(a0);
		}
		return MoserObjectUtils.getItemTypeFolders$0(a0);
	}

	static getFirstLevelQueryItems(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getFirstLevelQueryItems$1(a0);
		}
		return MoserObjectUtils.getFirstLevelQueryItems$0(a0);
	}

	static getFilters(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getFilters$0(a0);
		}
		return MoserObjectUtils.getFilters$1(a0);
	}

	static getCalculations(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getCalculations$0(a0);
		}
		return MoserObjectUtils.getCalculations$1(a0);
	}

	static removeQueryItem(a0, a1) {
		var args = arguments;
		if (args.length == 2 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.removeQueryItem$0(a0, a1);
		}
		return MoserObjectUtils.removeQueryItem$1(a0, a1);
	}

	static getMeasures(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return MoserObjectUtils.getMeasures$0(a0);
		}
		return MoserObjectUtils.getMeasures$1(a0);
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/MoserObjectUtils.js